<template>
    <div v-if="nodata" class="customized">
        <md-result-page img-url="/static/icon/noassets.png" text="Itoken has not been buy in this way" subtext="">
        </md-result-page>
        <md-button type="primary" round @click="go_tobuy">To buy</md-button>
    </div>
    
    <div class="scroll-list" v-else>
        <md-scroll-view  ref="listscrollView" :scrolling-x="false" @refreshing="$_onRefresh" :auto-reflow="true" :immediate-check-end-reaching="true"
            @end-reached="$_onEndReached">
            <md-scroll-view-refresh slot="refresh" slot-scope="{ scrollTop, isRefreshActive, isRefreshing }"
                :scroll-top="scrollTop" :is-refreshing="isRefreshing" :is-refresh-active="isRefreshActive"
                refresh-text="pull to refresh" refresh-active-text="release refreshable"
                refreshing-text="refresh"></md-scroll-view-refresh>
            <md-field class="historylist pt-0">
                <md-cell-item title="IToken" :brief="rtype" v-for="u in quota_list" v-bind:key="u.id" @click="go_continue_to_pay(u)">
                    <template slot="right">
                        <p>{{ u.itoken }}</p>
                        <p>
                            <span v-if="method === 'usdt'">{{ u.amount }} USDT</span>
                            <span v-else>₹ {{ u.amount }}</span>
                        </p>
                        <p>
                            <pointtext :text="u.status" type="success" v-if="method === 'usdt'"></pointtext>
                            <pointtext text="Paying" type="notline" v-if="method === 'inr' && u.status === 'pending'"></pointtext>
                            <pointtext text="In Review" type="notline" v-if="method === 'inr' && u.status === 'review'"></pointtext>
                            <pointtext text="Success" type="success" v-if="method === 'inr' && u.status === 'success'"></pointtext>
                            <pointtext text="Fail" type="fail" v-if="method === 'inr' && u.status === 'fail'"></pointtext>
                            <pointtext text="Cancel" type="default" v-if="method === 'inr' && u.status === 'cancel'"></pointtext>
                        </p>
                    </template>
                    <template slot="default">
                        <p class="mtime">Reward: {{ u.reward }}</p>
                        <p class="mtime" v-if="u.paymentslip_orderno">Orderno: {{ u.paymentslip_orderno }}</p>
                        <p class="mtime">{{ u.mtime }}</p>
                    </template>
                    <!-- <div slot="children" v-if="method === 'inr' && (u.last_status === 'dispatched' || u.last_status === 'reprocess') || u.last_status === 'inreview'">
                        <md-button type="primary" plain round @click="go_continue_to_pay(u)" v-if="u.last_status === 'inreview'">Check the details</md-button>
                        <md-button type="primary" plain round @click="go_continue_to_pay(u)" v-else>Continue to pay</md-button>
                    </div> -->
                </md-cell-item>
            </md-field>
            <md-scroll-view-more slot="more" :is-finished="isFinished" loading-text="Loading" finished-text="no more data">
            </md-scroll-view-more>
        </md-scroll-view>
    </div>
</template>

<script>
import iconimg from '@/components/iconimg'
import pointtext from '@/components/pointtext'
import { getbuyitokenhistory } from '@/request/api'

export default {
    name: 'deposihistorylist',
    props: {
        method: {
            type: String,
            default: 'usdt'
        }
    },
    components: {
        iconimg,
        pointtext
    },
    data() {
        return {
            quota_list: [],
            page: 1,
            limit: 10,
            isFinished: false,
            nodata: false,
            rtype: ''
        }
    },
    created() {
        if (this.method === 'usdt') {
            this.rtype = 'USDT';
        } else {
            this.rtype = 'INR'
        }
    },
    mounted() {
        window.ScrollViewTrigger2 = () => {
            this.$refs.listscrollView.triggerRefresh();
        }
    },
    methods: {
        $_onRefresh() {
            this.quota_list = [];
            this.page = 1;
            this.isFinished = true;
            this.get_list(true);
        },
        $_onEndReached() {
            if (this.isFinished) {
                return
            }
            this.get_list(false);
        },
        get_list(refresh) {
            this.$toast.loading("Loading..")
            getbuyitokenhistory({
                page: this.page,
                limit: this.limit,
                currency: this.method
            }).then(res => {
                this.$toast.hide();
                if (res.code === 200) {
                    if (res.data.count === 0) {
                        this.nodata = true;
                    } else {
                        this.quota_list = this.quota_list.concat(res.data.result);
                    }
                    if (this.quota_list.length < res.data.count) {
                        this.page = this.page + 1;
                        this.isFinished = false;
                    } else {
                        this.isFinished = true;
                    }
                } else {
                    this.$toast.failed(res.errmsg);
                }
                if(refresh) {
                    this.$refs.listscrollView.finishLoadMore();
                    this.$refs.listscrollView.finishRefresh();
                } else {
                    this.$refs.listscrollView.finishLoadMore();
                }
            })
        },
        go_tobuy() {
            this.$router.push('/transaction');
        },
        go_continue_to_pay(u) {
            if(this.method === 'inr' && (u.status === 'pending' || u.status === 'review')) {
                let ct_id = u.ct_id;
                if(!ct_id) {
                    ct_id = "None";
                }
                this.$router.push('/buyinrdetail/' + u.order_id + '/' + ct_id);
            }
        }
    }
}
</script>
<style scoped>
.scroll-list {
    height: 13rem;
}
.mtime {
    color: #666;
    font-size: 24px;
}

.historylist>>>.md-cell-item-right {
    display: block;
    color: #000000;
    font-size: 0.28rem;
    text-align: right;
}

.customized {
    height: 6.76rem;
}
.customized >>> .md-result {
    height: 75% !important;
}
.noassets {
    margin-top: 1.5rem;
}

.noassets>>>.md-result-image {
    width: 1.6rem;
}

.noassets>>>.md-result-text {
    margin: 0;
    color: #01080f;
    font-size: 0.12rem;
}

.noassets>>>.md-result-subtext {
    margin-top: 0.16rem;
    color: red;
    font-size: 0.28rem;
}
</style>



// WEBPACK FOOTER //
// src/views/recharge/deposihistorylist.vue